import { z } from 'zod';

import { type BlockType } from './base/baseSchema.js';
import { type Money } from './flowRunCost.js';

export interface LineItemActionUnit {
  actionUnitName: string;
  quantity: number;
  usageDescription: string;
  totalCost: Money;
  unitCostDescription: string;
}

export interface CostEstimateResponseLineItem {
  id: string;
  blockType: BlockType;
  blockName: string;
  totalCost: Money;
  actionUnits: LineItemActionUnit[];
  subFlow?: CostEstimateResponse;
}

export interface CostEstimateResponse {
  flowName: string;
  flowDescription: string | null;
  totalCost: Money;
  lineItems: CostEstimateResponseLineItem[];
}

export const CostEstimateRequestParamsSchema = z.object({
  quantityOverrideLineItems: z
    .array(
      z.object({
        blockId: z.string().uuid(),
        actionUnitName: z.string(),
        quantity: z.number(),
      })
    )
    .optional(),
});

export type CostEstimateRequestParams = z.infer<typeof CostEstimateRequestParamsSchema>;
